import { useEffect, useState } from 'react'
import { GuideView } from './GuideView'
import { getGuide } from '../../services/guides'

// Body for a guide grid window. A guide opened from chat may not be in the
// owner's list, so a missing id is loaded on its own.
export function GuideWindowBody({ guide, guideId, loading }) {
  const [extra, setExtra] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (guide || !guideId) {
      setExtra(null)
      setFailed(false)
      return undefined
    }
    let alive = true
    setFailed(false)
    getGuide(guideId)
      .then((next) => {
        if (alive) setExtra(next)
      })
      .catch(() => {
        if (alive) setFailed(true)
      })
    return () => {
      alive = false
    }
  }, [guide, guideId])

  const shown = guide || extra
  if (shown) {
    return (
      <div className="guide-window">
        <GuideView guide={shown} />
      </div>
    )
  }
  if (failed) return <div className="display-empty">Could not open this guide.</div>
  if (loading || guideId) return <div className="display-empty">Loading…</div>
  return <div className="display-empty">Select a guide from the list to view it.</div>
}

export default GuideWindowBody
